<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12" class="text-center my-16">
          <v-btn elevation="2" color="primary" outlined>
            <JsonExcel
              :data="data"
              worksheet="My Worksheet"
              name="export_langs.xlsx"
            >
            </JsonExcel
          ></v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import JsonExcel from 'vue-json-excel';
import english from '@/locales/en';
import thai from '@/locales/th';
export default {
  components: {
    JsonExcel,
  },
  data() {
    return {
      json_english: [],
      json_thai: [],
      data: [],
    };
  },
  mounted() {
    this.json_english = english;
    this.json_thai = thai;

    for (let items in this.json_english) {
      if (typeof this.json_english[items] === 'object') {
        let child1 = this.json_english[items];
        for (let item_ch1 in child1) {
          if (typeof child1[item_ch1] === 'object') {
            let child2 = child1[item_ch1];
            for (let item_ch2 in child2) {
              if (typeof child2[item_ch2] === 'object') {
                let child3 = child2[item_ch2];
                for (let item_ch3 in child3) {
                  if (typeof child3[item_ch3] === 'object') {
                    let child4 = child3[item_ch3];
                    for (let item_ch4 in child4) {
                      if (typeof child4[item_ch4] === 'object') {
                        let child5 = child4[item_ch4];
                        for (let item_ch5 in child5) {
                          if (typeof child5[item_ch5] === 'object') {
                            let child6 = child5[item_ch5];
                            for (let item_ch6 in child6) {
                              if (typeof child6[item_ch6] === 'object') {
                                let child7 = child6[item_ch6];
                                for (let item_ch7 in child7) {
                                  if (typeof child7[item_ch7] === 'string') {
                                    let thai7 =
                                      this.json_thai[items][item_ch1][item_ch2][
                                        item_ch3
                                      ][item_ch4][item_ch5][item_ch6] !==
                                      undefined
                                        ? this.json_thai[items][item_ch1][
                                            item_ch2
                                          ][item_ch3][item_ch4][item_ch5][
                                            item_ch6
                                          ][item_ch7]
                                        : '';
                                    this.data.push({
                                      path:
                                        items +
                                        '.' +
                                        item_ch1 +
                                        '.' +
                                        item_ch2 +
                                        '.' +
                                        item_ch3 +
                                        '.' +
                                        item_ch4 +
                                        '.' +
                                        item_ch5 +
                                        '.' +
                                        item_ch6 +
                                        '.' +
                                        item_ch7,
                                      vocabulary: item_ch7,
                                      eng: child7[item_ch7],
                                      th: thai7,
                                    });
                                  }
                                }
                              } else {
                                let thai6 =
                                  this.json_thai[items][item_ch1][item_ch2][
                                    item_ch3
                                  ][item_ch4][item_ch5] !== undefined
                                    ? this.json_thai[items][item_ch1][item_ch2][
                                        item_ch3
                                      ][item_ch4][item_ch5][item_ch6]
                                    : '';
                                this.data.push({
                                  path:
                                    items +
                                    '.' +
                                    item_ch1 +
                                    '.' +
                                    item_ch2 +
                                    '.' +
                                    item_ch3 +
                                    '.' +
                                    item_ch4 +
                                    '.' +
                                    item_ch5 +
                                    '.' +
                                    item_ch6,
                                  vocabulary: item_ch6,
                                  eng: child6[item_ch6],
                                  th: thai6,
                                });
                              }
                            }
                          } else {
                            let thai5 =
                              this.json_thai[items][item_ch1][item_ch2][
                                item_ch3
                              ][item_ch4] !== undefined
                                ? this.json_thai[items][item_ch1][item_ch2][
                                    item_ch3
                                  ][item_ch4][item_ch5]
                                : '';
                            this.data.push({
                              path:
                                items +
                                '.' +
                                item_ch1 +
                                '.' +
                                item_ch2 +
                                '.' +
                                item_ch3 +
                                '.' +
                                item_ch4 +
                                '.' +
                                item_ch5,
                              vocabulary: item_ch5,
                              eng: child5[item_ch5],
                              th: thai5,
                            });
                          }
                        }
                      } else {
                        let thai4 =
                          this.json_thai[items][item_ch1][item_ch2][
                            item_ch3
                          ] !== undefined
                            ? this.json_thai[items][item_ch1][item_ch2][
                                item_ch3
                              ][item_ch4]
                            : '';
                        this.data.push({
                          path:
                            items +
                            '.' +
                            item_ch1 +
                            '.' +
                            item_ch2 +
                            '.' +
                            item_ch3 +
                            '.' +
                            item_ch4,
                          vocabulary: item_ch4,
                          eng: child4[item_ch4],
                          th: thai4,
                        });
                      }
                    }
                  } else {
                    let thai3 =
                      this.json_thai[items][item_ch1][item_ch2] !== undefined
                        ? this.json_thai[items][item_ch1][item_ch2][item_ch3]
                        : '';
                    this.data.push({
                      path:
                        items +
                        '.' +
                        item_ch1 +
                        '.' +
                        item_ch2 +
                        '.' +
                        item_ch3,
                      vocabulary: item_ch3,
                      eng: child3[item_ch3],
                      th: thai3,
                    });
                  }
                }
              } else {
                let thai2 =
                  this.json_thai[items][item_ch1] !== undefined
                    ? this.json_thai[items][item_ch1][item_ch2]
                    : '';
                this.data.push({
                  path: items + '.' + item_ch1 + '.' + item_ch2,
                  vocabulary: item_ch2,
                  eng: child2[item_ch2],
                  th: thai2,
                });
              }
            }
          } else {
            let thai1 =
              this.json_thai[items] !== undefined
                ? this.json_thai[items][item_ch1]
                : '';
            this.data.push({
              path: items + '.' + item_ch1,
              vocabulary: item_ch1,
              eng: child1[item_ch1],
              th: thai1,
            });
          }
        }
      } else {
        this.data.push({
          path: items,
          vocabulary: items,
          eng: this.json_english[items],
          th: this.json_thai[items] !== undefined ? this.json_thai[items] : '',
        });
      }
    }

    //console.log(this.data);
  },
};
</script>

<style>
</style>